import eventWaitlistService from '../../services/eventWaitlistService'

class EventWaitlistController {
  fetchEventWaitlist = eventWaitlistService.fetchEventWaitlist
  addToEventWaitlist = eventWaitlistService.addToEventWaitlist
  deleteFromEventWaitlist = eventWaitlistService.deleteFromEventWaitlist
  addToCustomerEventWaitlist = eventWaitlistService.addToCustomerEventWaitlist
}

export default new EventWaitlistController()
 


// WEBPACK FOOTER //
// ../src/controllers/eventWaitlistController/eventWaitlistController.js